import { getOptionDefaultValue } from '../../components/DownloadDialog/config';
import normalizeFormatMimeType from '../normalizeFormatMimeType';
import { isBulkCopyCropAspect } from './copyCropAspectPresets';

/**
 * @param {object} [dialogParams] - AssetsCopyDialog onConfirm payload (may include presetId)
 * @returns {object|null}
 */
function hasCropPayload(crop) {
  return crop && typeof crop === 'object'
    && ['x1', 'y1', 'x2', 'y2'].every((k) => typeof crop[k] === 'number');
}

export default function buildCopyConvertingParams(dialogParams) {
  const cropPayload = hasCropPayload(dialogParams?.crop) ? dialogParams.crop : null;
  const cropAspectPayload = isBulkCopyCropAspect(dialogParams?.cropAspect)
    ? dialogParams.cropAspect
    : null;
  if (!dialogParams || (dialogParams.mimeType === 'original' && !cropPayload && !cropAspectPayload)) {
    return null;
  }
  const {
    mimeType: mimeTypeRaw,
    quality,
    resizing,
    presetId,
    presetName,
    width,
    height,
    isArchive,
    organizeByCollections,
    withoutWatermark,
    resolution,
    usePdfProxy,
  } = dialogParams;

  const mimeType = normalizeFormatMimeType(mimeTypeRaw);

  const config = {
    mimeType,
    organizeByCollections,
    isArchive,
    withoutWatermark,
    resolution,
    usePdfProxy,
    _id: presetId,
    ...(presetName ? { presetName } : {}),
  };

  config.quality = quality;
  config.resizing = resizing;

  if (resizing !== getOptionDefaultValue('resizing')) {
    if (Number.isFinite(Number(width))) config.width = Number(width);
    if (Number.isFinite(Number(height))) config.height = Number(height);
  }

  if (cropPayload) {
    config.crop = {
      x1: cropPayload.x1,
      y1: cropPayload.y1,
      x2: cropPayload.x2,
      y2: cropPayload.y2,
    };
  }

  if (cropAspectPayload) {
    config.cropAspect = cropAspectPayload;
  }

  return config;
}
